<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Afastamentos</h5>
                <hr>
                <TabView @tab-change="tab">
					<TabPanel header="Cadastro" class="p-mt-3">
						<NovoAfastamento/>
					</TabPanel>
					<TabPanel header="Transferência" class="p-mt-3">
						<Transferencia ref="tranferencia"/>
					</TabPanel>
					<TabPanel header="Lista" class="p-mt-3">
						<ListaAfastamentos ref="listaAfastamento"/>
					</TabPanel>
                </TabView>
			</div>
		</div>
    </div>
</template>

<script>
import NovoAfastamento from '@/components/pages/movimento/afastamentos/NovoAfastamento.vue';
import ListaAfastamentos from '@/components/pages/movimento/afastamentos/ListaAfastamentos.vue';
import Transferencia from '@/components/pages/movimento/afastamentos/Transferencia.vue'

export default {
	methods: {
		tab(event) {
			if(event.tab.header == 'Transferência') {
				this.$refs.tranferencia.prepararTransferencia();
			} else if(event.tab.header == 'Lista') {
				this.$refs.listaAfastamento.listarCnpjs();
			}
		}
	},	
	components: {
		'Transferencia': Transferencia,
		'ListaAfastamentos': ListaAfastamentos,
		'NovoAfastamento': NovoAfastamento,
    }
}
</script>

<style>

</style>